import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { Reveal } from '@/components/Reveal';

const frameworks = ['NIST CSF', 'SOC 2', 'HIPAA', 'PCI-DSS', 'ISO 27001', 'CIS', 'FERPA/COPPA', 'Google Workspace', 'Microsoft 365', 'Email DNS (SPF/DKIM/DMARC)'];

export function TrustBand(): JSX.Element {
  return (
    <section id="security" className="border-y border-white/10 py-14 md:py-20">
      <div id="compliance" className="container-content grid grid-cols-1 items-center gap-8 md:grid-cols-[1.2fr_0.8fr]">
        <Reveal>
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.14em] text-nexus-purple-light">
              Security &amp; compliance, by design
            </span>
            <h2 className="mt-3 font-display text-2xl font-bold text-nexus-ink md:text-[30px]">
              Built to walk into a board meeting with the report already done.
            </h2>
            <p className="mt-3 max-w-[520px] text-white/70">
              Posture tracking maps to the frameworks your clients actually answer to —
              general and vertical-specific alike. AI triages every alert before it
              reaches a human, the on-prem monitoring agent has zero inbound
              site-firewall exposure, and integration secrets are encrypted at rest,
              fail-closed in production.
            </p>
            <Button
              component={Link}
              to="/security"
              size="small"
              variant="text"
              endIcon={<ArrowForwardIcon fontSize="small" />}
              className="mt-3 pl-0 normal-case text-nexus-purple-light"
            >
              See the full trust center
            </Button>
          </div>
        </Reveal>
        <Reveal delay={120}>
          <div className="flex flex-wrap justify-start gap-2.5 md:justify-end">
            {frameworks.map((f) => (
              <Chip
                key={f}
                label={f}
                className="border border-white/10 bg-white/[0.04] py-3.5 font-medium text-nexus-ink"
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
